import React from 'react';

import { Row, Text } from 'farmhub-ui-core';

import { useAppSelector } from 'app';
import { selectAppState } from 'slice';
import { LOGO } from 'utils';

import { Image } from './styles';

type LogoProps = {
  isExpand?: boolean;
  onRedirect: () => void;
};

const Logo = ({ onRedirect, isExpand: isExpland = true }: LogoProps) => {
  const app = useAppSelector(selectAppState);

  return (
    <Row
      justifyContent={isExpland ? 'flex-start' : 'center'}
      styles={{ gap: 6 }}
      width={isExpland ? 'fit-content' : '100%'}
      onClick={onRedirect}
    >
      <Image src={app?.system?.avatar ?? LOGO} />
      {isExpland && (
        <Row styles={{ gap: 2 }} width="fit-content">
          <Text color="dark" lineNumber={1} size="sm" weight="extraBold">
            {app?.system?.displayName ?? 'HUBADMIN'}
          </Text>
        </Row>
      )}
    </Row>
  );
};

export default Logo;
